export default "<ion-app>\n  <app-header></app-header>\n  <!--<app-menu></app-menu>-->\n  <ion-router-outlet id=\"content1\"></ion-router-outlet>\n</ion-app>";